// OpenAI Ads Pixel - ładowany warunkowo, dopiero po zgodzie marketingowej.
// SSR-bezpieczny: wszystkie odwołania do window/document są w funkcjach
// wywoływanych tylko w przeglądarce (nigdy podczas builda/SSR).

const PIXEL_ID = "GztFNYt2gcPhMojWbJZjwd";

// Wstrzykuje SDK i inicjalizuje pixel. Idempotentne (guard w.oaiq).
export const loadOaiqPixel = () => {
  if (typeof window === "undefined") return;
  if (window.oaiq) return; // już załadowany - nie dubluj
  (function (w, d, s, u) {
    if (w.oaiq) return;
    var q = function () {
      q.q.push(arguments);
    };
    q.q = [];
    w.oaiq = q;
    var j = d.createElement(s);
    j.async = 1;
    j.src = u;
    var f = d.getElementsByTagName(s)[0];
    f.parentNode.insertBefore(j, f);
  })(window, document, "script", "https://bzrcdn.openai.com/sdk/oaiq.min.js");

  window.oaiq("init", { pixelId: PIXEL_ID, debug: true });
};

// Zdarzenie konwersji - wyłącznie po POTWIERDZONYM sukcesie wysyłki formularza.
// Nie zrobi nic, jeśli pixel nie jest załadowany (brak zgody marketingowej).
// Dokładny kod z OpenAI Ads Manager (custom event lead_submitted).
export const fireLeadSubmitted = () => {
  if (typeof window !== "undefined" && window.oaiq) {
    window.oaiq(
      "measure",
      "custom",
      { type: "custom" },
      { custom_event_name: "lead_submitted" }
    );
  }
};
